import { Box } from "theme-ui";
import { useAnimation, motion } from "framer-motion";
import Tippy from "@tippyjs/react/headless";

import ToolTipSelector from "./ToolTipSelector";
import * as styles from "./ToolTip.styles";

export default function ToolTip({ toolTip, children }) {
  const initialStyle = { y: "50px", opacity: 0 };
  const transition = { duration: 0.2, ease: "easeOut" };

  const controls = useAnimation();

  function onMount() {
    controls.start({ opacity: 1, y: "0px", transition });
  }

  function onHide({ unmount }) {
    controls.start({ ...initialStyle, transition }).then(unmount);
  }

  return (
    <Tippy
      render={() => {
        return (
          <motion.div animate={controls} style={initialStyle}>
            <Box sx={styles.toolTipContainer}>
              <ToolTipSelector
                component={toolTip.component}
                props={toolTip.props}
              />
            </Box>
          </motion.div>
        );
      }}
      animation={true}
      onMount={onMount}
      onHide={onHide}
      touch={["hold", 500]}
    >
      {children}
    </Tippy>
  );
}
